import { render, staticRenderFns } from "./supportIcon.vue?vue&type=template&id=0b84f1c1&scoped=true"
import script from "./supportIcon.vue?vue&type=script&lang=js"
export * from "./supportIcon.vue?vue&type=script&lang=js"
import style0 from "./supportIcon.vue?vue&type=style&index=0&id=0b84f1c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84f1c1",
  null
  
)

export default component.exports